import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Datepicker from "react-tailwindcss-datepicker";
import { useDispatch, useSelector } from 'react-redux';
import { roles } from '../../utils/constants';
import api from "../../services/api";
import CanvasJSReact from "./canvasjs.react";
import TableLoader from '../../shared/TableLoader';
import NoDataFound from '../../shared/NoDataFound';
import { SetComponentId } from '../../redux/counterSlice'
import AddLineItem from "../Orders/AddLineItem";


function Dashboard() {
  const dispatch = useDispatch()
  dispatch(SetComponentId(7))
  var CanvasJSChart = CanvasJSReact.CanvasJSChart;
  const navigate = useNavigate()

  const [campstats, setCampstats] = useState([])
  const [spentdata, setSpentdata] = useState([])
  const [data, setData] = useState([])
  const Headdate = useSelector(state => state.Head.date)
  const [value, setValue] = useState({
    startDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
    endDate: new Date(),
  });
  const [permissions, setPermissions] = useState([])
  const [showLineItem, setShowLineItem] = useState(false);
  const [amid, setAmid] = useState("");
  const [orderName, setOrderName] = useState("");
  const [companyId, setCompanyId] = useState();
  const [salesType, setSalesType] = useState("");
  const [impressionData, setImpressionaData] = useState();

  const formatYAxisLabel = (e) => {
    const suffixes = ["", "K", "M", "B"];
    let order = Math.max(Math.floor(Math.log(e.value) / Math.log(1000)), 0);

    if (order > suffixes.length - 1)
      order = suffixes.length - 1;

    const value = e.value / Math.pow(1000, order);

    return value.toFixed(1) + suffixes[order];
  }

  const options = {
    animationEnabled: true,
    exportEnabled: true,
    theme: "light2",
    // title: {
    // text: "Spent by Date"
    // },
    height: 280, // Set a custom height for the graph

    axisY: {
      title: "Spent",
      titleFontColor: "#adb5bd",
      labelFontColor: "#adb5bd",
      gridColor: "#e8eaed", // Set a light color for the horizontal grid lines
      labelFontSize: 12, // Adjust the font size for the date labels
      titleFontSize: 15,
      labelFormatter: formatYAxisLabel
    },
    axisX: {
      title: "Date",
      interval: spentdata?.length > 6 ? 1 : 0.25,
      titleFontColor: "#adb5bd",
      labelFontColor: "#adb5bd",
      // valueFormatString: "MMM DD, YYYY" // Format for displaying dates on the X-axis
      valueFormatString: "MMM DD",// Format for displaying dates on the X-axis,
      labelFontSize: 12, // Adjust the font size for the date labels
      titleFontSize: 15,
      // labelAngle: -45, // Rotate the date labels for better readability
      tickLength: 0, // Remove the tick marks on the X-axis
      titleMargin: 20,

    },
    data: [{
      type: "line",
      toolTipContent: "{x}: ₹{y}",
      lineThickness: 3, // Increase the thickness of the line

      // lineColor: "#e8eaed", // Apply a light color to the lines
      // markerColor: "#e8eaed" ,// Apply a light color to the data ma
      dataPoints: []
    }]
  };

  const ImpressionGraph = {
    animationEnabled: true,
    exportEnabled: true,
    theme: "light2",
    // title: {
    // text: "Spent by Date"
    // },
    height: 280, // Set a custom height for the graph

    axisY: {
      title: "Impressions",
      titleFontColor: "#adb5bd",
      labelFontColor: "#adb5bd",
      gridColor: "#e8eaed", // Set a light color for the horizontal grid lines
      labelFontSize: 12, // Adjust the font size for the date labels
      titleFontSize: 15,
      labelFormatter: formatYAxisLabel
    },
    axisX: {
      title: "Date",
      interval: 1,
      titleFontColor: "#adb5bd",
      labelFontColor: "#adb5bd",
      // valueFormatString: "MMM DD, YYYY" // Format for displaying dates on the X-axis
      valueFormatString: "MMM DD",// Format for displaying dates on the X-axis,
      labelFontSize: 12, // Adjust the font size for the date labels
      titleFontSize: 15,
      // labelAngle: -45, // Rotate the date labels for better readability
      tickLength: 0, // Remove the tick marks on the X-axis
      titleMargin: 20,

    },
    data: [{
      type: "line",
      toolTipContent: "{x}: {y}",
      lineThickness: 3, // Increase the thickness of the line

      lineColor: "#639615", // Apply a light color to the lines
      markerColor: "#639615",// Apply a light color to the data ma
      dataPoints: []
    }]
  };



  const ClickGraph = {
    animationEnabled: true,
    exportEnabled: true,
    theme: "light2",
    // title: {
    // text: "Spent by Date"
    // },
    height: 280, // Set a custom height for the graph

    axisY: {
      title: "Clicks",
      titleFontColor: "#adb5bd",
      labelFontColor: "#adb5bd",
      gridColor: "#e8eaed", // Set a light color for the horizontal grid lines
      labelFontSize: 12, // Adjust the font size for the date labels
      titleFontSize: 15,
      labelFormatter: formatYAxisLabel
    },
    axisX: {
      title: "Date",
      interval: 1,
      titleFontColor: "#adb5bd",
      labelFontColor: "#adb5bd",
      // valueFormatString: "MMM DD, YYYY" // Format for displaying dates on the X-axis
      valueFormatString: "MMM DD",// Format for displaying dates on the X-axis,
      labelFontSize: 12, // Adjust the font size for the date labels
      titleFontSize: 15,
      // labelAngle: -45, // Rotate the date labels for better readability
      tickLength: 0, // Remove the tick marks on the X-axis
      titleMargin: 20,

    },
    data: [{
      type: "line",
      toolTipContent: "{x}: {y}",
      lineThickness: 3, // Increase the thickness of the line
      lineColor: "#f0a95d", // Apply a light color to the lines
      markerColor: "#f0a95d",
      dataPoints: []
    }]
  };

  function convertNumberToKM(number) {
    const suffixes = ["", "K", "M", "B"];
    let order = Math.max(Math.floor(Math.log(number) / Math.log(1000)), 0);

    if (order > suffixes.length - 1)
      order = suffixes.length - 1;

    const value = number / Math.pow(1000, order);

    return value.toFixed(1) + suffixes[order];
  }


  for (let i = 0; i < spentdata?.length; i++) {
    const date = new Date(spentdata[i].x * 1000);
    const spent = parseFloat(spentdata[i].y.toFixed(2))

    const imp = parseInt(spentdata[i].imp)
    const click = parseInt(spentdata[i].click)
    console.log(spent, imp, click)
    options.data[0].dataPoints.push({ x: date, y: spent });
    ImpressionGraph.data[0].dataPoints.push({ x: date, y: imp });
    ClickGraph.data[0].dataPoints.push({ x: date, y: click });
  }



  useEffect(() => {
    const role = localStorage.getItem("role")
    if (role !== roles.advertiser)
      navigate("/pagenotfound")
    getSpentGraph()
    getTopCampaign()
  }, [])

  useEffect(() => {
    // getCampaignStats(Headdate)
  }, [Headdate])

  const handleValueChange = (newValue) => {
    setValue(newValue);
    getSpentGraph(newValue)
  }

  const getSpentGraph = async (date) => {
    try {
      const response = await api({
        url: `/user/advertisers/spentgraph`,
        method: "POST",
        responseType: "json",
        data: {
          date
        }
      });
      setSpentdata(response?.data?.data)
      setPermissions(response?.data?.tableColumns)
    } catch (error) {
      console.log("error");
    }
  };

  // const getCampaignStats = async (date) => {
  //   try {
  //     const response = await api({
  //       url: `/user/advertisers/camptype_stats`,
  //       method: "POST",
  //       responseType: "json",
  //       data: {
  //         date
  //       }
  //     });
  //     setCampstats(response.data)
  //   } catch (error) {
  //     console.log("error");
  //   }
  // };
  const getTopCampaign = async (date) => {
    try {
      const response = await api({
        url: `/user/advertisers/top_orders`,
        method: "POST",
        responseType: "json",
      });
      setData(response?.data?.data)
    } catch (error) {
      console.log("error");
    }
  };

  const calculateEcpm = (spent, impressions) => {
    let ecpm = (spent / impressions) * 1000;
    return !isNaN(ecpm) && ecpm !== Infinity
      ? parseFloat(ecpm).toFixed(2)
      : "-";
  }
  const handleLineItem = () => {
    setShowLineItem(false);
    setAmid("");
  };
  return (
    <>
    <div >
      <div >
        {/* <div>
 <table className='table-base'>
 <thead>
 <tr>
 <td></td>
 <th>Local</th>
 <th>Editorial</th>
 <th>DFP</th>
 </tr>
 </thead>
 <tbody>
 <tr>
 <th className='text-start'>Today</th>
 <td></td>
 <td></td>
 <td></td>
 </tr>
 <tr>
 <th className='text-start'>Yesterday</th>
 <td></td>
 <td></td>
 <td></td>
 </tr>
 </tbody>
 </table>
 </div>

 <section className='d-flex justify-content-between mt-5'>
 <select className='form-select me-4'>
 <option>Status</option>
 <option>Active</option>
 </select>

 <div className='me-4'>
 <input type='date' cla const brandAdsPreview = async(post_ids)=>{
    try {
      const res = await api({
        url : "lineitems/post_idsPreview",
        method: "POST",
        responseType: 'json',
        data: {post_ids}
      })
      setCreativePreview(res.data)
    } catch (error) {
      console.error('Error @ brandAdsPreview', error)
    }
  }ssName='form-control' />
 </div>

 <select className='form-select me-4'>
 <option>Advertiser</option>
 <option>Active</option>
 </select>

 <div className='me-4' style={{ minWidth: '200px' }}>
 <input type='text' className='form-control' placeholder='Campaign Search' />
 </div>

 <select className='form-select'>
 <option>Campaign Type</option>
 <option>Active</option>
 </select>
 </section> */}
        <div className='col-xl-12'>
          {(localStorage.getItem("role") === roles.advertiser && (permissions.includes('impressions') || permissions.includes('clicks') || permissions.includes('spent'))) ? (<div className='card mb-5' >
            <div className='card-header align-items-center d-flex'>
              <h2 className='card-title mb-0 flex-grow-1'> Performance Insights</h2>
              <div className='flex-shrink-0'>
                <div className='border rounded-lg border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500 mb-0 my-n1 w-66'>
                  <Datepicker
                    primaryColor={"blue"}
                    value={value}
                    onChange={handleValueChange}
                    showShortcuts={true}
                  />
                </div>
              </div>
            </div>
            <div className='card-body'>
              <div className='row'>
                {(localStorage.getItem("role") === roles.advertiser && permissions.includes('spent')) ? (<div className='col-4'>
                  <div className='card'>
                    <div className='card-header'>
                      <h4> Budget </h4>
                    </div>
                    <div className='card-body'>
                      <CanvasJSChart options={options}
                      />
                    </div>
                  </div>
                </div>) : null}
                {(localStorage.getItem("role") === roles.advertiser && permissions.includes('impressions')) ? (<div className='col-4'>
                  <div className='card'>
                    <div className='card-header'>
                      <h4> Audience Viewed </h4>
                    </div>
                    <div className='card-body'>
                      <CanvasJSChart options={ImpressionGraph} />
                    </div>
                  </div>
                </div>) : null}
                {(localStorage.getItem("role") === roles.advertiser && permissions.includes('clicks')) ? (<div className='col-4'>
                  <div className='card'>
                    <div className='card-header'>
                      <h4> Audience Engaged </h4>
                    </div>
                    <div className='card-body'>
                      <CanvasJSChart options={ClickGraph} />
                    </div>
                  </div>
                </div>) : null}
              </div>

            </div>
          </div>) : null}
          <div className='row'>
            <div className='col-12'>
              <div className=''>
                <div className='mb-3'>
                    <h4>Today Top 10 Orders</h4>
                </div>
                <div className=''>
                  <div className='table-responsive'>
                    <table className='table table-bordered'>
                      <thead>
                        <tr>
                            <th>Order Name</th>
                          {(localStorage.getItem("role") === roles.advertiser && permissions.includes('impressions')) ? (<th>Audience Viewed</th>) : null}
                          {(localStorage.getItem("role") === roles.advertiser && permissions.includes('clicks')) ? (<th>Audience Engaged</th>) : null}
                          {(localStorage.getItem("role") === roles.advertiser && permissions.includes('ecpm')) ? (<th>ECPM/CPD</th>) : null}
                          {(localStorage.getItem("role") === roles.advertiser && permissions.includes('spent')) ? (<th>Budget</th>) : null}
                        </tr>
                      </thead>
                      {
                        (data?.length) ?
                          <tbody>
                            {
                              data?.map((item, index) => {
                                return (
                                  <tr>
                                    <td
                                      className="order-link"
                                      onClick={() => {
                                        setShowLineItem(true);
                                        setAmid(item.order_id);
                                        setOrderName(item.order_name);
                                        setCompanyId(item.company_id);
                                        setSalesType(item.order_type);
                                        setImpressionaData(item.impclicks?.[0]);
                                      }}
                                    >
                                      {item.order_name || "-"}
                                    </td>
                                    {(localStorage.getItem("role") === roles.advertiser && permissions.includes('impressions')) ? (<td>{item.impclicks[0].adv_total_imp}</td>) : null}
                                    {(localStorage.getItem("role") === roles.advertiser && permissions.includes('clicks')) ? (<td>{item.impclicks[0].adv_total_click}</td>) : null}
                                    {(localStorage.getItem("role") === roles.advertiser && permissions.includes('ecpm')) ? (<td>{calculateEcpm(item.impclicks[0].adv_spent, item.impclicks[0].adv_total_imp)}</td>) : null}
                                    {(localStorage.getItem("role") === roles.advertiser && permissions.includes('spent')) ? (<td>₹{convertNumberToKM(item.impclicks[0].adv_spent)}</td>) : null}
                                  </tr>
                                )
                              })
                            }

                          </tbody> : (!data?.length) ? <NoDataFound colspan="10" /> : <TableLoader colspan="4" />
                      }
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>





        </div>



      </div>
      {/*<div className='content-right bg-empty colors-box'>
        <div className='h-100 overflow-xauto'>
          <div className='simplebar-wrapper'>

            <div className='simplebar-content-wrapper'>
               <div className='row'>
 <div className='col-12'>
 <div className='card mb-5'>
 <div className='card-header'>
 <h4>Overall Stats</h4>
 </div>
 <div className='card-body'>
 <div className='table-responsive'>
 <table className='table table-bordered'>
 <thead>
 <tr>
 <th>Campaign Count</th>
 <th>Type</th>
 <th>Impression</th>
 <th>Clicks</th>
 <th>ECPM/CPD</th>
 <th>SPENT</th>
 </tr>
 </thead>
 <tbody>
 {
 campstats?.map((item, index) => {
 return (
 <tr>
 <td>{item.count}</td>
 <td><span className={item.campaignType === "CPM" ? 'badge bg-soft-success text-success' : item.campaignType === "CPC" ? "badge bg-soft-success text-primary" : "badge bg-soft-success text-danger"}>{item.campaignType}</span></td>
 <td>{item.totalImpressions}</td>
 <td>{item.totalClicks}</td>
 <td>{item.campaignType === "CPC"
 ? (item.ecpm.toFixed(2) + " " + "(CPC)")
 : item.campaignType === "CPM"
 ? (item.ecpm.toFixed(2) + " " + "(CPM)")
 : (item.ecpm.toFixed(2) + " " + "(CPD)")}</td>
 <td>₹{convertNumberToKM(item.spent)}</td>
 </tr>
 )
 })
 }

 </tbody>
 </table>
 </div>
 </div>
 </div>
 </div>


 </div>
 {
 campstats?.map((item, index) => {
 return (
 <tr>
 <td>{item.count}</td>
 <td><span className={item.campaignType === "CPM" ? 'badge bg-soft-success text-success' : item.campaignType === "CPC" ? "badge bg-soft-success text-primary" : "badge bg-soft-success text-danger"}>{item.campaignType}</span></td>
 <td>{item.totalImpressions}</td>
 <td>{item.totalClicks}</td>
 <td>{item.campaignType === "CPC"
 ? (item.ecpm.toFixed(2) + " " + "(CPC)")
 : item.campaignType === "CPM"
 ? (item.ecpm.toFixed(2) + " " + "(CPM)")
 : (item.ecpm.toFixed(2) + " " + "(CPD)")}</td>
 <td>₹{convertNumberToKM(item.spent)}</td>
 </tr>
 )
 })
 }




 {
                campstats?.map((item, index) => {
                  return (
                    <div className='card card-h-100 mb-4 '>
                      <div className='card-header'>
                        <div class="d-flex flex-wrap align-items-center">
                          <h5>
                            {item.campaignType}
                          </h5>
                          <div class="ms-auto">
                            <span title='Campaigns Count' className='round1-box'> {item.count} </span>
                          </div>
                        </div>
                      </div>
                      <div className='card-body'>
                        <div class="col-sm align-self-center">
                          <div class="mt-4 mt-sm-0">
                            <p class="mb-1">Budget</p>
                            <h4>₹{convertNumberToKM(item.spent)}</h4>

                            <p class="text-muted mb-4"> {item.campaignType === "CPC"
                              ? (item.ecpm.toFixed(2) + " " + "(CPC)")
                              : item.campaignType === "CPM"
                                ? (item.ecpm.toFixed(2) + " " + "(CPM)")
                                : (item.ecpm.toFixed(2) + " " + "(CPD)")} <i class="mdi mdi-arrow-up ms-1 text-success"></i></p>

                            <div class="row g-0">
                              <div class="col-6">
                                <div>
                                  <p class="mb-27 text-muted text-uppercase font-size-11">Audience Viewed</p>
                                  <h5 class="fw-medium">{convertNumberToKM(item.totalImpressions)}</h5>
                                </div>
                              </div>
                              <div class="col-6">
                                <div>
                                  <p class="mb-27 text-muted text-uppercase font-size-11">Audience Engaged</p>
                                  <h5 class="fw-medium">{convertNumberToKM(item.totalClicks)}</h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })
              } 
            </div>
          </div>
        </div>
      </div>*/}
    </div>

      {
        showLineItem ? (
          <AddLineItem
            show={showLineItem}
            setShow={handleLineItem}
            order_id={amid}
            salesType={salesType}
            orderName={orderName}
            company={companyId}
            impressionData={impressionData}
            permissions={permissions}
          />
        ) : null
      }
    </>
  )
}

export default Dashboard